<template>
  <star-condition-layout
    ref="starCondition"
    :onSearch="handleSearch"
    :onReset="reset"
    :loading="loading"
  >
    <star-condition-cell label="站点类型">
      <a-select v-model="searchCondition.spiderClassId" :style="{ width: '100%' }">
        <a-select-option v-for="cls in classList" :value="cls.spiderClassId">
          {{ cls.spiderClassName }}
        </a-select-option>
      </a-select>
    </star-condition-cell>

    <star-condition-cell label="站点ID">
      <a-input v-model="searchCondition.spiderId" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="站点名称">
      <a-input v-model="searchCondition.spiderName" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="国家">
      <CountrySelect v-model="searchCondition.country" />
    </star-condition-cell>

    <star-condition-cell label="申请时间" class="large">
      <a-range-picker :style="{ width: '100%' }" v-model="searchCondition.timeRange" />
    </star-condition-cell>
  </star-condition-layout>
</template>

<script>
import moment from 'moment'
import CountrySelect from '@/components/CountrySelect/'
import _ from 'lodash'

export default {
  components: { CountrySelect },
  props: {
    onSearch: {
      type: Function,
      required: true
    },
    loading: Boolean,
    classList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchCondition: {
        spiderClassId: undefined,
        spiderId: undefined,
        spiderName: undefined,
        country: undefined,
        timeRange: null
      },
      mediaType: 'news'
    }
  },

  created: function () {
    let type = this.$route.query.type
    if (type != null) {
      this.mediaType = type
    }
  },

  watch: {
    classList() {
      if (this.searchCondition.spiderClassId) return
      this.searchCondition.spiderClassId = this.classList.find(
        (d) => d.type === this.mediaType
      )?.spiderClassId
      if (!this.searchCondition.spiderClassId) {
        this.searchCondition.spiderClassId = this.classList.find(
          (d) => d.type === 'news'
        )?.spiderClassId
      }
      this.handleSearch()
    }
  },

  methods: {
    reset() {
      this.searchCondition = {
        spiderClassId: this.searchCondition.spiderClassId,
        spiderId: '',
        spiderName: '',
        country: undefined,
        timeRange: null
      }
      this.handleSearch()
    },

    getFormatTime(d, isFirst) {
      if (!d) {
        return undefined
      }
      const hms = isFirst ? '00:00:00' : '23:59:59'
      return moment(d).format(`YYYY-MM-DD ${hms}`)
    },

    handleSearch() {
      const condition = {
        ...this.searchCondition,
        applyStartTime: this.getFormatTime(this.searchCondition.timeRange?.[0], true),
        applyEndTime: this.getFormatTime(this.searchCondition.timeRange?.[1], false)
      }
      this.onSearch(_.omitBy(condition, _.isUndefined))
    }
  }
}
</script>
